import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import Close from 'icons/button_close.svg'

export const Wrap = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: ${calculateResponsiveSize(18)} ${calculateResponsiveSize(95)} ${calculateResponsiveSize(18)} ${calculateResponsiveSize(100)};
    font-family: 'adobe-caslon-pro';
    font-size: ${calculateResponsiveSize(16)};
    color: #ffffff;
    line-height: 1.4;
    background: #2E1619;
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
    z-index: 10000;
  }
  &.show {
    .cookies-banner {
      transform: translateY(0);
    }
  }
  .cookies-banner-accept-btn {
    display: none;
  }
  ${mediaMax('mobile')} {
    .cookies-banner {
      padding: ${calculateMobileResponsiveSize(7)} ${calculateMobileResponsiveSize(20)} ${calculateMobileResponsiveSize(13)} ${calculateMobileResponsiveSize(20)};
      font-size: ${calculateMobileResponsiveSize(14)};
    }
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaMax('mobile')} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${calculateMobileResponsiveSize(9)};
    width: ${calculateMobileResponsiveSize(256)};
    margin: 0 auto;
    text-align: center;
  }
`

export const Buttons = styled.div`
  display: flex;
  gap: ${calculateResponsiveSize(10)};
  & .accept {
    color: #2E1619;
    background: #FAF8F5;
  }
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(15)};
  }
`

export const ButtonClose = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(42)};
  width: ${calculateResponsiveSize(21)};
  height: ${calculateResponsiveSize(21)};
  transform: translateY(-50%);
  background: url(${Close}) center center no-repeat;
  background-size: ${calculateResponsiveSize(21)} auto;
  cursor: pointer;
  ${mediaMax('mobile')} {
    top: ${calculateMobileResponsiveSize(10)};
    right: ${calculateMobileResponsiveSize(10)};
    width: ${calculateMobileResponsiveSize(20)};
    height: ${calculateMobileResponsiveSize(20)};
    transform: translateY(0);
    background-size: ${calculateMobileResponsiveSize(20)} auto;
  }
`
